module.exports = __webpack_public_path__ + "img/cun0.0fa92afe.jpg";